module.exports = __webpack_public_path__ + "img/ku_logo.5693db92.png";